import { render, staticRenderFns } from "./SubscribeSoloPage.vue?vue&type=template&id=64c3f34a"
import script from "./SubscribeSoloPage.vue?vue&type=script&lang=js"
export * from "./SubscribeSoloPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports